import { v4 as uuid } from "uuid";
import {
  cap,
  cap1,
  cap2,
  headPhone,
  hodie,
  jacket,
  jeansCombo,
  leatherJacket,
  shirt,
  shirt1,
  suit,
  sweater,
  trousers,
  tshirt,
  tshirt1,
  tshirtCombo,
} from "../../assets";
/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: uuid(),
    brand: "Nike",
    title: "Bluetooth Headphone",
    priceAfterDiscount: 4559,
    originalPrice: 5559,
    discount: 15,
    category: "Summer Collection",
    sizeAvailable: ["S", "M", "L"],
    idealFor: ["Men"],
    Image: headPhone,
    rating: 5,
    alt: "Bluetooth Headphone",
  },

  {
    _id: uuid(),
    brand: "AmorMente",
    title: "Woven Beanie Cap",
    priceAfterDiscount: 685,
    originalPrice: 1250,
    discount: 57,
    category: "Summer Collection",
    sizeAvailable: ["S", "M"],
    idealFor: ["Women"],
    Image: cap1,
    rating: 5,
    alt: "Woven Beanie Cap",
  },
  {
    _id: uuid(),
    brand: "TRIPR",
    title: "Full Cap",
    priceAfterDiscount: 1111,
    originalPrice: 1550,
    discount: 19,
    sizeAvailable: ["S", "M"],
    idealFor: ["Women"],
    category: "Winter Collection",
    Image: cap,
    rating: 3,
    alt: "Full Cap",
  },
  {
    _id: uuid(),
    brand: "Reebok",
    title: "Stylish Cap",
    priceAfterDiscount: 2111,
    originalPrice: 2999,
    discount: 30,
    sizeAvailable: ["S", "M"],
    idealFor: ["Men"],
    category: "Summer Collection",
    Image: cap2,
    rating: 5,
    alt: "Stylish Cap",
  },
  {
    _id: uuid(),
    brand: "Nike",
    title: "Stylish Hodie",
    priceAfterDiscount: 4999,
    originalPrice: 11111,
    discount: 57,
    sizeAvailable: ["S", "L"],
    idealFor: ["Men"],
    category: "Winter Collection",
    Image: hodie,
    rating: 5,
    alt: "Stylish Hodie",
  },
  {
    _id: uuid(),
    brand: "Nike",
    title: "Mens Jacket",
    priceAfterDiscount: 3999,
    originalPrice: 4999,
    discount: 19,
    sizeAvailable: ["M", "L"],
    idealFor: ["Men"],
    category: "Winter Collection",
    Image: jacket,
    rating: 4,
    alt: "Mens Jacket",
  },
  {
    _id: uuid(),
    brand: "AmorMente",
    title: "Jeans Combo",
    priceAfterDiscount: 4599,
    originalPrice: 9999,
    discount: 57,
    sizeAvailable: ["M", "L"],
    idealFor: ["Women"],
    category: "Monsoon Collection",
    Image: jeansCombo,
    rating: 3,
    alt: "Jeans Combo",
  },
  {
    _id: uuid(),
    brand: "Reebok",
    title: "Leather Jacket",
    priceAfterDiscount: 3111,
    originalPrice: 5999,
    discount: 21,
    sizeAvailable: ["s", "M", "L"],
    idealFor: ["Men"],
    category: "Monsoon Collection",
    Image: leatherJacket,
    rating: 3,
    alt: "Leather Jacket",
  },
  {
    _id: uuid(),
    brand: "AmorMente",
    title: "Stylish Shirt",
    priceAfterDiscount: 2999,
    originalPrice: 9999,
    discount: 77,
    sizeAvailable: ["M", "L"],
    idealFor: ["Men"],
    category: "Winter Collection",
    Image: shirt,
    rating: 1,
    alt: "Stylish Shirt",
  },
  {
    _id: uuid(),
    brand: "TRIPR",
    title: "Woman Stylish Jacket",
    priceAfterDiscount: 999,
    originalPrice: 2999,
    discount: 31,
    sizeAvailable: ["M", "L"],
    idealFor: ["Women"],
    category: "Summer Collection",
    Image: shirt1,
    rating: 2,
    alt: "Woman Stylish Jacket",
  },
  {
    _id: uuid(),
    brand: "Nike",
    title: "Stylish Suit",
    priceAfterDiscount: 4999,
    originalPrice: 9999,
    discount: 51,
    sizeAvailable: ["S", "M", "L"],
    idealFor: ["Men"],
    category: "Monsoon Collection",
    Image: suit,
    rating: 5,
    alt: "Stylish Shirt",
  },
  {
    _id: uuid(),
    brand: "Reebok",
    title: "Sylish Sweater",
    priceAfterDiscount: 2299,
    originalPrice: 6666,
    discount: 61,
    sizeAvailable: ["S", "M", "L"],
    idealFor: ["Women"],
    category: "Winter Collection",
    Image: sweater,
    rating: 3,
    alt: "Sylish Sweater",
  },
  {
    _id: uuid(),
    brand: "AmorMente",
    title: "Stylish Trousers",
    priceAfterDiscount: 1599,
    originalPrice: 1999,
    discount: 15,
    sizeAvailable: ["S", "M"],
    idealFor: ["Women"],
    category: "Monsoon Collection",
    Image: trousers,
    rating: 1,
    alt: "Stylish Trousers",
  },
  {
    _id: uuid(),
    brand: "TRIPR",
    title: "Stylish Tshirt",
    priceAfterDiscount: 759,
    originalPrice: 1759,
    discount: 19,
    sizeAvailable: ["S", "M"],
    idealFor: ["Men"],
    category: "Monsoon Collection",
    Image: tshirt,
    rating: 4,
    alt: "Stylish Tshirt",
  },
  {
    _id: uuid(),
    brand: "Reebok",
    title: "Stylish Tshirt",
    priceAfterDiscount: 999,
    originalPrice: 1959,
    discount: 11,
    sizeAvailable: ["S", "M"],
    idealFor: ["Women"],
    category: "Summer Collection",
    Image: tshirt1,
    rating: 2,
    alt: "Stylish Tshirt",
  },
  {
    _id: uuid(),
    brand: "TRIPR",
    title: "Tshirt Combo",
    priceAfterDiscount: 2659,
    originalPrice: 5559,
    discount: 51,
    sizeAvailable: ["S", "M", "L"],
    idealFor: ["Women"],
    category: "Summer Collection",
    Image: tshirtCombo,
    rating: 3,
    alt: "Tshirt Combo",
  },
];
